"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fillBookmarkIds = void 0;
const createId_1 = require("./createId");
const fillBookmarkIds = (groups) => groups.map(({ label, bookmarks }) => ({
    id: (0, createId_1.createId)(),
    label,
    bookmarks: bookmarks.map(({ label, url }) => ({
        id: (0, createId_1.createId)(),
        label,
        url,
    })),
}));
exports.fillBookmarkIds = fillBookmarkIds;
